export const BACKEND_URL = process.env['BACKEND_URL'];
export const ADMIN_URL = process.env['ADMIN_URL'];
export const FRONTEND_URL = process.env['FRONTEND_URL'];
